import { RootState } from 'store/rootReducer';

export const getLoading = (state: RootState) => state.auth.loading;
export const getAuthenticated = (state: RootState) => state.auth.authenticated;
export const getUser = (state: RootState) => state.auth.user;

export const getIsVip = (state: RootState) => Boolean(state.auth.user?.is_vip);
export const getIsPremium = (state: RootState) =>
  Boolean(state.auth.user?.is_premium);

export const getIsBuyer = (state: RootState) =>
  Boolean(state.auth.user?.is_buyer);

export const getIsInterstitial = (state: RootState) =>
  Boolean(state.auth.user?.is_interstitial);
